/**
 * Snackbar Component - Template
 * ===============================
 */

export const SNACKBAR_TEMPLATE: string = `
<div class="ec-snackbar" ng-class="$ctrl.getContainerClasses()" role="status">
  <div ng-class="$ctrl.getContentClasses()">
    <p ng-if="$ctrl.showTitle && $ctrl.title" ng-class="$ctrl.getTitleClasses()">{{ $ctrl.title }}</p>
    <div ng-if="$ctrl.hasContent" ng-class="$ctrl.getTextClasses()" ng-transclude></div>
    <p ng-if="!$ctrl.hasContent && $ctrl.text" ng-class="$ctrl.getTextClasses()">{{ $ctrl.text }}</p>
  </div>
  <button
    ng-if="$ctrl.showAction"
    type="button"
    ng-class="$ctrl.getActionClasses()"
    ng-click="$ctrl.handleActionClick($event)"
  >{{ $ctrl.actionLabel }}</button>
</div>
`;

export default SNACKBAR_TEMPLATE;
